import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { langCommon } from "../../../locales";
import { AmountServer } from "../../../server";
import { generateOperationFormConfig } from './config'

const server = AmountServer.UserAddress

const DEFAULT_OPERATION_DATA = {
    AddressId: null,
    Address: null,
}

type OperateModeType = 'update'


export const Operation = forwardRef((props: any, ref: any) => {
    const { onSuccess, options } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('update');

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
                ...(mode === 'update' ? val : {})
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else if (val) {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(server.update, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(langCommon?.operateSuccess);
            changeVisible(false);
            onSuccess?.();
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return generateOperationFormConfig({ formData, mode, options });
    }, [formData, mode, options]);

    return (
        <div>
            <Modal
                title={'更新钱包地址信息'}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    const { Id, Address } = formData
                    const params = {
                        AddressId: Id,
                        Address,
                    }
                    run(params)
                }}
            >
                <EditForm
                    componentId="card-product-operation"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 6 },
                        wrapperCol: { span: 18 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                />
            </Modal>
        </div>
    );
})
